import './EvaluationInviteModal.css';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Modal, Input, Tooltip, notification } from 'antd';
import { useState } from 'react';
import { queryToObject } from '../../../utils/processQueryString';
import useTranslations from '../../../hooks/useTranslations';
import { hasValidQueryParams } from '../../../utils/Validations/isUrl';

const EvaluationInviteModal = ({ open, hideModal, setQueryLink }) => {
  const { t } = useTranslations();
  const [invitationLink, setInvitationLink] = useState('');

  const handleCreateInvitation = async () => {
    if (invitationLink.length === 0) {
      notification.warning({
        message: t('NOTIFICATION_EMPTY_FIELD_TITLE'),
        description: t('NOTIFICATION_EMPTY_FIELD_DESCRIPTION'),
      });
      return;
    }

    try {
      const url = new URL(invitationLink);
      if (`${url.origin}/` !== process.env.RAZZLE_RUNTIME_AUTH_ZERO_M2M_AUDIENCE) {
        notification.warning({
          message: t('NOTIFICATION_INVALID_DOMAIN_TITLE'),
          description: t('NOTIFICATION_INVALID_DOMAIN_DESCRIPTION'),
        });
        return;
      }
      const queryString = url.search;
      const queryParams = queryToObject(queryString);

      if (!hasValidQueryParams(queryParams)) {
        notification.warning({
          message: t('NOTIFICATION_INVALID_QUERY_TITLE'),
          description: t('NOTIFICATION_INVALID_QUERY_DESCRIPTION'),
        });
        return;
      }
      setQueryLink(queryParams);
      notification.success({
        message: t('NOTIFICATION_SUCCESS_TITLE'),
        description: t('NOTIFICATION_SUCCESS_DESCRIPTION'),
      });
      handleClose();
    } catch (error) {
      notification.error({
        message: t('NOTIFICATION_ERROR_TITLE'),
        description: t('NOTIFICATION_ERROR_DESCRIPTION'),
      });
    }
  };

  const handleInputChange = e => {
    setInvitationLink(e.target.value);
  };
  const handleClose = () => {
    setInvitationLink('');
    hideModal();
  };

  return (
    <Modal
      visible={open}
      onCancel={handleClose}
      width='70%'
      style={{ maxWidth: '600px' }}
      className='evaluation-invite-modal'
      footer={null}
      centered>
      <div className='flex w-50 h-auto flex-col gap-5'>
        <p className='font-semibold'>{t('INVITATION_LINK_MODAL_TITLE')}:</p>
        <div className='flex items-center gap-3'>
          <Input
            type='text'
            autoComplete='off'
            name='InvitationLink'
            className='w-full'
            placeholder={t('INVITATION_LINK_MODAL_PLACEHOLDER')}
            value={invitationLink}
            onChange={handleInputChange}
          />
          <Tooltip title={t('INVITATION_LINK_MODAL_TOOLTIP')}>
            <QuestionCircleOutlined style={{ fontSize: '18px', color: 'gray' }} />
          </Tooltip>
        </div>
        <div className='flex flex-row-reverse'>
          <button
            onClick={handleCreateInvitation}
            className='py-2 px-4 bg-maya-blue self-end font-bold rounded-2xl text-white hover:cursor-pointer'
            data-testid='dev-profile-redirect-profile-button'>
            {t('INVITATION_LINK_MODAL_BUTTON')}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default EvaluationInviteModal;
